import { render, staticRenderFns } from "./CenterBox.vue?vue&type=template&id=64f8b01e&"
import script from "./CenterBox.vue?vue&type=script&lang=js&"
export * from "./CenterBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports